// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isContentBlockResult = objectOf({
  info: string,
  template: objectOf({
    id: string,
    name: string,
    included_count: number,
    created: objectOf({
      time: number,
      name: string,
      d_id: string,
      api_key_name: string,
    }),
    last_edited: objectOf({
      time: number,
      name: string,
      d_id: string,
      api_key_name: string,
    }),
    content_type: string,
    api_identifier: string,
    description: string,
    content: string,
    is_draft: boolean,
    marked_as_deleted: boolean,
    link_includer_sequence: number,
    content_block_inclusion_sequence: number,
    tag_names: arrayOf(string),
    territory_ids: arrayOf(string),
    dnd_json: string,
    is_dnd_template: boolean,
  }),
});

export const isGetEngagementContentBlocksIdResult = objectOf({
  id: string,
  name: string,
  included_count: number,
  created: objectOf({
    time: number,
    name: string,
    d_id: string,
    api_key_name: string,
  }),
  last_edited: objectOf({
    time: number,
    name: string,
    d_id: string,
    api_key_name: string,
  }),
  content_type: string,
  api_identifier: string,
  description: string,
  content: string,
  is_draft: boolean,
  marked_as_deleted: boolean,
  link_includer_sequence: number,
  content_block_inclusion_sequence: number,
  tag_names: arrayOf(string),
  territory_ids: arrayOf(string),
  dnd_json: string,
  is_dnd_template: boolean,
});
